import type { ReactNode } from 'react';
import React, { useEffect } from 'react';
import type { StatsigOptions } from 'statsig-react';
import { Statsig, StatsigProvider } from 'statsig-react';

import { DEPLOY_ENVIRONMENT } from '@soundxyz/utils/const';
import { useStatsigUser } from '@store/statsig';
import { isMainSoundxyzSite } from '@utils/constants';
import { useParams } from './params';

const options: StatsigOptions = {
  environment: {
    tier: DEPLOY_ENVIRONMENT,
  },
};

export function SoundStatsigProvider({ children }: { children: ReactNode }) {
  const { user: statsigUser } = useStatsigUser();
  const { feature_gates } = useParams();

  // Override any feature gates that are explicitly set in the URL
  // In the form of ?feature_gates=my_feature:1,other_feature:0
  useEffect(() => {
    // Clear out existing overrides to prevent persisting between sessions
    Statsig.removeGateOverride();
    // Skip if on prod or there are not gates present
    if (!feature_gates || isMainSoundxyzSite) return;
    const overrides = feature_gates.split(',');
    overrides.forEach(override => {
      const [gate, enabled] = override.split(':');
      if (!gate || !enabled) return;
      Statsig.overrideGate(gate, enabled === '1');
    });

    return () => Statsig.removeGateOverride();
  }, [feature_gates]);

  return (
    <StatsigProvider
      sdkKey="client-WyTMblfQNdDzbRSjIOXMGvHcybDqIKwrnCEfPPawUW0"
      waitForInitialization={false}
      user={statsigUser}
      options={options}
    >
      {children}
    </StatsigProvider>
  );
}
